import {Component, Input, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { DetailViewComponent } from '../../widgets/detailsview/detailView.component';
import { AddDossierComponent } from '../add-dossier/add-dossier.component';
import {UsercourrierService} from "../../services/frapper/usercourrier.service";
import { VisualizePieceComponent } from '../visualize-piece/visualize-piece.component';
import {DossierService} from "../../services/frapper/dossier.service";
import {MyCONST} from "../../CONST/myConst";
import {AddPieceComponent} from "../add-piece/add-piece.component";
import {AlertesService} from "../../services/public/alertes.service";
import {NgxUiLoaderService} from "ngx-ui-loader";
import { ViewDetailsTransmissioncourrierComponent } from '../view-details-transmissioncourrier/view-details-transmissioncourrier.component';
import {TransmissioncourrierComponent} from "../transmissioncourrier/transmissioncourrier.component";
import {CustomService} from "../../services/frapper/custom.service";
import { DatePipe } from '@angular/common';
import {RegistreService} from "../../services/frapper/registre.service";
import { AssignedService } from '../../services/frapper/assigned.service';
import { AddAvisComponent } from '../add-avis/add-avis.component';
import { AddNaturalisationComponent } from '../add-naturalisation/add-naturalisation.component';
import { NaturalisationService } from '../../services/frapper/naturalisation.service';


@Component({
  selector: 'ngx-form-courier',
  templateUrl: './view-details-courrier.component.html',
  styleUrls: ['./view-details-courrier.component.scss']
})
export class ViewDetailsCourrierComponent implements OnInit{
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  data:any;
  dataAllInformation:any;
  dataPiecesJointes:any  =[];
  type: any;
  courriers: any[] = [];
  internesCourriers: any[] = [];
  internesPrincipals: any[] = [];
  isButtonDisabled: boolean = true;
  latestSt = null;
  profil: string ;
  pageavis:number = 0;
  Information_Dossier =[]
  @Input() parentModal: BsModalRef;
  user = null;
  Allow_Piece_Actions = false
  Allow_send_To_Procureur = false
  Allow_send_To_Greffe = false
  Allow_send_To_President = false
  Allow_send_To_External = false
  avisOuverts: any[] = [];
  CAN_CREATE_DOSSIER = false
  ACTION_ALLOWED = false

  CAN_DO_AVIS = false
  ALL_ST =[];
   user_info;
   MUST_ANSWER_AVIS = false;
  CAN_NATURALISATION = false;

  my_tribunal:any = null

  rolesAutorises = [
    'AGENT DU COURRIER',
    'AGENT DU COURRIER PRESIDENT',
    'AGENT DU COURRIER GREF',
    'AGENT DU COURRIER CIVIL'
  ];

  workFlowsActionsAllowed:any = []

  constructor(private _formBuilder: FormBuilder,private options: ModalOptions,
              private ngxService: NgxUiLoaderService,
              private alerte:AlertesService,
              private customService:CustomService,
              private penalCourrierService: PenalCourrierService,
              private userCourrierService: UsercourrierService,
              private registreService: RegistreService,
              private naturalisationService: NaturalisationService,
              public bsModalRef: BsModalRef,
              private datePipe: DatePipe,
              private assignService: AssignedService,
              private modalService: BsModalService) {
    this.data = this.options.initialState.data;
    // this.type = this.options.initialState.type;
    this.my_tribunal = JSON.parse(localStorage.getItem('my_tribunal'))

     this.user_info = JSON.parse(localStorage.getItem('me')).name
     console.log('the user: ',this.user_info);
    //console.log({'the details courrier ': this.data})

    
  }



  activePane = 0;

  onTabChange($event: number) {
    this.activePane = $event;
    console.log('onTabChange', $event);
  }

  actionToDo(){


    if(this.dataAllInformation.workflow_state=='Bureau courrier' ){
      this.Allow_Piece_Actions = true
      console.log(this.profil)
      this.registreService.getOneRegistreNoAuth(this.dataAllInformation.registre).then(res =>{
        console.log('res.message ==> ',res.message.registre)
        let registre = res.message.registre //
        if(registre.is_exit_registre !='1'){
          this.Allow_send_To_External =false
          if(this.profil=='AGENT DU COURRIER'){
            this.Allow_send_To_Procureur = true
          }else {
            // this.Allow_send_To_Greffe = true
            //this.Allow_send_To_President = true
            if(this.profil=='AGENT DU COURRIER PRESIDENT'){
              this.Allow_send_To_President = true
              this.Allow_send_To_Greffe = false
            }
            if(this.profil=='AGENT DU COURRIER GREF'){
              this.Allow_send_To_President = false
              this.Allow_send_To_Greffe = true
            }
            if(this.profil=='AGENT DU COURRIER CIVIL'){
              this.Allow_send_To_President = true
              this.Allow_send_To_Greffe = true
              this.Allow_send_To_Procureur = true
            }

          }
        }else{
          if (this.profil=='AGENT DU COURRIER PRESIDENT' || this.profil=='AGENT DU COURRIER GREF' || this.profil=='AGENT DU COURRIER CIVIL' || this.profil=='AGENT DU COURRIER') {
            this.Allow_send_To_External =true
          }

        }
      },err =>{
        this.alerte.errorNotification('Registre', 'Le Registre mentionn3 n\'est plus disponible !')
      })

    }
    else {
      this.Allow_Piece_Actions = false
      this.Allow_send_To_Procureur = false
      this.Allow_send_To_Greffe = false
      this.Allow_send_To_President = false
      this.CAN_DO_AVIS = false
      this.CAN_NATURALISATION = false
    }

    console.log('PROFIl ',this.profil.toUpperCase() )
    // if(this.data.registre!='Courrier Depart'){
      
      if(this.data.categorie != 'sortant'){
     
      const workstate = this.data.workflow_state.toUpperCase(); 

      if (
        this.profil === 'JUGE' && workstate === 'JUGE' ||
        this.profil === 'SUB PROCUREUR' && workstate === 'SUBSTITUT' ||
        this.profil === 'GREFFIER D\'INSTRUCTION' ||
        this.profil === 'GREFFIER' ||
        this.profil === 'GREFFIER EN CHEF' ||
        this.profil === 'PROCUREUR' ||
        this.profil === 'PRESIDENT DU TRIBUNAL' ||
        this.profil === 'AGENT ENROLEMENT' ||
        this.profil === 'AGENT ENROLEMENT PENAL' 
      ) {
        this.CAN_CREATE_DOSSIER = true;
      }

      if(this.profil.toUpperCase() == 'JUGE' || this.profil.toUpperCase() == 'GREFFIER EN CHEF' || this.profil.toUpperCase() == 'GREFFIER'  || this.profil.toUpperCase() == 'SUB PROCUREUR' || this.profil.toUpperCase() == 'PROCUREUR' || this.profil.toUpperCase() == 'PRESIDENT DU TRIBUNAL' || this.profil.toUpperCase() == 'AGENT ENROLEMENT' || this.profil.toUpperCase() == 'AGENT ENROLEMENT PENAL')
        {
          
          this.CAN_CREATE_DOSSIER =true
         
        }

      // check au niveau du st

      let filter = '[["type_of_st" , "=","Courrier"],["doctype_name" , "=","'+this.data.name+'"]]'
        this.customService.getSoitTransmisObject(filter).then(async res=>{
          console.log(res)
          this.ALL_ST=res.data
    
          this.latestSt = this.getLatestSt(this.ALL_ST);

          if ((this.latestSt != null && this.latestSt?.is_for_avis != 1 && this.latestSt?.designation_interne == this.user_info) || this.latestSt == null ) {
            
            this.CAN_DO_AVIS = true
            if (this.profil == "AGENT NATURALISATION") {

              let filter =this.my_tribunal==null? null : '[["tribunal" , "=","'+this.my_tribunal.name+'"],["numero_de_courrier" , "=","'+this.data.name+'"]]'

              let check_naturalisation =  await this.naturalisationService.getAllDemandes(filter)
              console.log('checknaturalisation=>', check_naturalisation.data );
      
              if (check_naturalisation.data.length == 0) {
                this.CAN_NATURALISATION = true
              }
              
              
            } 
            if(this.profil=='AGENT DU COURRIER' || this.profil=='AGENT ENROLEMENT' || this.profil == 'AGENT ENROLEMENT PENAL' || this.profil=='AGENT DU COURRIER PRESIDENT' || this.profil=='AGENT DU COURRIER GREF' || this.profil=='AGENT DU COURRIER CIVIL'){
              this.CAN_DO_AVIS = false
            }
           

          }
          // if ((this.data.numero_dossier != null || this.data.numero_dossier != undefined )) {
          //   this.CAN_DO_AVIS = false            
          // }
        
          console.log('stss ', this.latestSt);
          console.log('stss ', this.ALL_ST);
          if (this.data.numero_dossier != null || (this.latestSt != null && this.latestSt?.is_for_avis != 1 && this.latestSt?.designation_interne != this.user_info)) {
            this.CAN_CREATE_DOSSIER =false
          }
          
        })

    }
   

    // if(!this.rolesAutorises.includes(this.profil)){
    //  // this.getDossierAttribue(this.data.numero_courrier, this.data.numero_dossier)
    // }


  }
  

  getAllCourriers() {
    // this.courriers = this.penalCourrierService.getCourrier();
   // console.log({'the couuuurrriieerrss': this.courriers});
  }
  closeWithMessage(message: string) {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden.emit(message);
  }

  getAllCourriersInternes() {
    this.internesCourriers = this.data;
  }





  openModalDetailView(data: any,type: string) {
    const config: ModalOptions = {
      initialState: {
        data: data,
        type: type,
        parentModal : null
      }
    }

     // Ouvrir le modal
     const modalRef = this.modalService.show(DetailViewComponent, Object.assign({}, config, { class: type == 'courrier' || type == 'substituts'  ? 'modal-md ': 'modal-lg '  }));

     // Mettre à jour l'option initialState avec le modalRef
     modalRef.content.parentModal = modalRef;
  }


  openModalAddPiece() {

    const config: ModalOptions = {
      initialState: {
        type_doctype:this.userCourrierService.Docatype_courrier_principal,
        num_courrier: this.data.numero_courrier,
        doctype:this.dataAllInformation,
        field_to_update:'pieces_jointe_au_courrier'
        // message: message
      }
    };
    // this.penalService.hiddeModal(this.parentModal);
    const modalRef = this.modalService.show(AddPieceComponent, Object.assign({}, config, {class:'modal-lg '}));
  }
  imprimeNumero(data) {
    const config: ModalOptions = {
      initialState: {
       
        data: data,
        is_ticket : true
      }
    }



    // Ouvrir le modal
    const modalRef = this.modalService.show(VisualizePieceComponent, Object.assign({}, config, { class: 'modal-lg ' }));

    // Mettre à jour l'option initialState avec le modalRef
  }
  openModalVisualPiece(key) {
    const URL=MyCONST.API_URL+key.fichier
    console.log('urllll ', URL);
    const config: ModalOptions = {
      initialState: {
        data: URL,
        url:URL,

        parentModal : null
      }
    }



    // Ouvrir le modal
    const modalRef = this.modalService.show(VisualizePieceComponent, Object.assign({}, config, { class: 'modal-lg ' }));

    // Mettre à jour l'option initialState avec le modalRef
  }
  // openModalVisualPiece(data: any) {
  //   const URL=MyCONST.API_URL+data.fichier
  //   const config: ModalOptions = {
  //     initialState: {
  //       data: 'https://petapixel.com/assets/uploads/2022/06/what-is-a-jpeg-featured.jpg',
  //       url:URL,
  //       parentModal : null
  //     }
  //   }

  //   // Ouvrir le modal
  //   const modalRef = this.modalService.show(VisualizePieceComponent, Object.assign({}, config, { class: 'modal-lg ' }));

  //   // Mettre à jour l'option initialState avec le modalRef
  // }

  _closeModal(){
    this.bsModalRef.hide()
    // this.bsModalRef.hide()
  }

  openModalTransmission(data: any,type: string) {
    const config: ModalOptions = {
      ignoreBackdropClick: false,
      backdrop: true,
      initialState: {

        data: data,
        type: type,
        // is_for_avis:
        parentModal : null
      }
    }
    return new Promise<string>((resolve, reject) => {
      const modalRef = this.modalService.show(TransmissioncourrierComponent, Object.assign({}, config, {class:'modal-xl '}));
       modalRef.content.parentModal = modalRef;
       modalRef.onHidden.subscribe((value: string) => {
         resolve(value); // Résoudre la promesse avec la valeur retournée
       });
     }).then(async (value: string) => {
 
       if ( value == "success") {
         this.closeWithMessage("")
       }
 
 
     });
    const modalRef = this.modalService.show(TransmissioncourrierComponent, Object.assign({}, config, { class:   'modal-xl '  }));

    // Mettre à jour l'option initialState avec le modalRef
    modalRef.content.parentModal = modalRef;

  }

  openModalAddDossier(step: string,data:any) {
    data = this.dataAllInformation
    const config: ModalOptions = {
      backdrop: true,
      initialState: {
        showAddCourrier: false,
        data: data,
        step: step,
        parentModal: null // Initialiser parentModal à null
      }
    }

    // Ouvrir le modal
    // this.penalCourrierService.hiddeModal(this.parentModal);


    return new Promise<string>((resolve, reject) => {
     const modalRef = this.modalService.show(AddDossierComponent, Object.assign({}, config, {class:'modal-xl modal-addDossier '}));
      modalRef.content.parentModal = modalRef;
      modalRef.onHidden.subscribe((value: string) => {
        resolve(value); // Résoudre la promesse avec la valeur retournée
      });
    }).then(async (value: string) => {

      if ( value == "success") {
        this.closeWithMessage("")
      }


    });


  }

  openModalAddNaturalisation(data:any) {
    data = this.dataAllInformation
    data['numero_de_courrier'] = data.name
    const config: ModalOptions = {
      backdrop: true,
      initialState: {
        data: data,
        type:'courrier'
  
      }
    }

    // Ouvrir le modal
    // this.penalCourrierService.hiddeModal(this.parentModal);


    return new Promise<string>((resolve, reject) => {
     const modalRef = this.modalService.show(AddNaturalisationComponent, Object.assign({}, config, {class:'modal-xl modal-addDossier '}));
      modalRef.content.parentModal = modalRef;
      modalRef.onHidden.subscribe((value: string) => {
        resolve(value); // Résoudre la promesse avec la valeur retournée
      });
    }).then(async (value: string) => {

      if ( value == "success") {
        this.closeWithMessage("")
      }


    });


  }


  getFormattedDate(date): string {
    return this.datePipe.transform(date, 'dd-MM-yyyy');
  }

  // async getDossierAttribue(numero_courrier,numero_dossier=null){
  //   console.log('numero_courrier ===> ',numero_courrier, ' numero_dossier ===> ',numero_dossier);
    
  //   try {
  //     let filter = '[["numero_courrier" , "=","' + numero_courrier + '"]]'
  //   let filter_1 = '[["name" , "=","' + numero_dossier + '"]]'

  //   let dossiers = (await this.dossierService.getAllMyDossiers(filter_1)).data
  //   console.log('numero_courrier ===> ',numero_courrier)
  //   console.log('Dossier ===> ',dossiers)
  //   for(let doc of dossiers){
  //     let inf = {
  //       "name": doc.name,
  //       "workflow_state": doc.workflow_state,
  //       "numero_courrier": doc.numero_courrier,
  //     }
  //     this.Information_Dossier.push(inf)
  //   }
  //   console.log('Dossierinf ===> ',this.Information_Dossier)
  //   } catch (error) {
  //     console.log('error getDossierAttribue ', error);

  //   }

  // }

  updateValueforChange(value,key){
    this.dataAllInformation[key]=value
  }

  updateValue(){
    this.ngxService.start()
    console.log('update data courrier: ',this.dataAllInformation)
    this.userCourrierService.updateCourrier(this.dataAllInformation.name,this.dataAllInformation).then(res=>{
      this.dataAllInformation=res.data
      this.data = this.dataAllInformation
      this.actionToDo()
      this.alerte.successNotification('Courrier','Mise a jour effectuee!')
      // this.penalCourrierService.hiddeModal(this.parentModal);
      // this.modalService.hide()
      this.closeWithMessage('success')
      this.ngxService.stop()
    },err=>{
      this.alerte.errorNotification('Courrier','Erreur lors de la mise a jour du courrier')
      this.ngxService.stop()
    })
  }

  updateState(new_state){
    this.ngxService.start()
    this.userCourrierService.updateSatate(this.data.name,new_state).then(async res => {
      this.alerte.successNotification('Courrier ','Courrier mis à jour avec succés')
      this.ngxService.stop();
      this.closeWithMessage("success")
      
    // await this.refresh()
      // this.openModalCourrierDetails(res.data)
    },err =>{
      this.ngxService.stop();
      this.alerte.errorNotification('Courrier ','Erreur lors du mis à jour du Courrier')
      console.log('Error ==> ',err)
    })
  }

  // recuperer le dernier st
  private getLatestSt(data: any[]): any {
    if (!data || data.length === 0) {
      return null;
    }

    // Trie  en ordre décroissant
    const sortedData = data.sort((a, b) => new Date(b.creation).getTime() - new Date(a.creation).getTime());

    return sortedData[0];
  }
  async refresh(){
    this.ngxService.start()
    this.userCourrierService.getOneCourrierPrincipal(this.data.name).then(res =>{
      this.dataAllInformation = res.data
      this.data = res.data
      this.actionToDo()

      this.dataPiecesJointes = this.dataAllInformation.pieces_jointe_au_courrier
      //console.log('-p-p-p-p---> ', this.dataPiecesJointes)
    });
    let filter = '[["type_of_st" , "=","Courrier"],["doctype_name" , "=","'+this.data.name+'"]]'
    this.customService.getSoitTransmisObject(filter).then(res=>{
      console.log(res)
      this.ALL_ST=res.data

      this.latestSt = this.getLatestSt(this.ALL_ST);
      

    })

    this.ngxService.stop()
  }

  openModalAddAvis(avis = null) {
  

      let config: ModalOptions = {
        initialState: {
         
        }
      };
      
      if (avis != null) {
        config = {
          initialState: {
              data: avis,
              emeteur: this.user_info,
              owner: avis.owner
           }
        }
      }else{
        config = {
          initialState: {
            doctype : this.data.demande_avis[0].parenttype,
            doctype_name: this.data.demande_avis[0].parent,
           emeteur: this.user_info,
          //  owner: this.data.demande_avis[0].owner,
           opened_avis: this.avisOuverts
           }
        }
      }
    return new Promise<string>((resolve, reject) => {
      const modalRef = this.modalService.show(AddAvisComponent, Object.assign({}, config, {class:'modal-lg '}));
      modalRef.onHidden.subscribe((value: string) => {
        resolve(value); // Résoudre la promesse avec la valeur retournée
      });
    }).then(async (value: string) => {
  
      if ( value == "success") {
        console.log("refresssshh=> ",value );
  
      }
  
  
    });
  
    }
    async UnassignAvis(avis: any = null) {
      this.ngxService.start();
    
      try {
        // Retirer l'assignation
        const res = await this.assignService.removeAssignation(
          avis.parenttype,
          avis.parent,
          avis.user_demand3
        );
        console.log('elements=>',avis.parenttype,avis.parent, avis.user_demand3);
        
    
        if (res !== null) {
    
          await this.assignService.removeReadAuth(avis.parenttype, avis.parent, avis.user_demand3); // remove dans partage
          // Modifier seulement le bon `demande_avis` dans la liste
          const updatedAvisList = this.data.demande_avis.map((item: any) => {
            if (item.name === avis.name) {
              return { ...item, is_open: 0 }; // Cloturer l'avis
            }
            return item;
          });
    
          const body_content = {
            demande_avis: updatedAvisList
          };
    
          // Mettre à jour le courrier avec la nouvelle liste `demande_avis`
          await this.userCourrierService.updateCourrier(avis.parent, body_content)
            .then(_res => {
              this.alerte.successNotification("Avis", "Avis clos pour cet utilisateur");
            })
            .catch(error => {
              console.error('Erreur de mise à jour du dossier:', error);
              this.alerte.errorNotification('', "Une erreur s'est produite, veuillez réessayer");
            })
            .finally(() => this.ngxService.stop());
        } else {
          this.ngxService.stop();
        }
    
      } catch (error) {
        console.error('Erreur inattendue:', error);
        this.alerte.errorNotification("Avis", "Une erreur s'est produite");
        this.ngxService.stop();
      }
    }

  ngOnInit() {
    try {
      this.ngxService.start()

      this.userCourrierService.getOneCourrierPrincipal(this.data.name).then(res => {
        this.dataAllInformation = res.data;
        this.data = res.data;
        console.log('datacourrier ===> ', this.data);
        
        this.actionToDo();
        this.avisOuverts = [];
      
        // Vérifier s'il y a une demande d'avis à répondre
        this.avisOuverts = this.data.demande_avis.filter(
          avis => avis.user_demand3 === this.user_info && avis.is_open === 1
        );
         
      
        if (this.avisOuverts.length > 0) {
          this.MUST_ANSWER_AVIS = true;
          // this.ownersToAnswer = avisOuverts.map(avis => avis.owner);

          console.log(' avis à répondre :', this.avisOuverts);
        }
      
        console.log('Information Of The Courriers ===>', this.data);
      

        
        this.userCourrierService.getNextActionWorkFlow(this.dataAllInformation).then(
          res => {
            console.log('Workflow ===> ', res);
            this.workFlowsActionsAllowed = res.message;
            if (this.workFlowsActionsAllowed.length == 0 && this.data.workflow_state != "Sans suite" ) {
              this.ACTION_ALLOWED = true;
              
            }
            console.log('workFlowsActionsAllowed ==> ', this.workFlowsActionsAllowed);
          },
          err => {
            console.log('Error ===> ', err);
          }
        );
      
      
      
        this.dataPiecesJointes = this.dataAllInformation.pieces_jointe_au_courrier;
      });
      
      this.ngxService.stop()
    } catch (error) {
      this.ngxService.stop()
    }

    //console.log('inf subs == '+this.data);
   
    this.profil = localStorage.getItem('profil');
    // this.penalCourrierService.hiddeModal(this.parentModal);
    console.log('cancreatedossier '+ this.CAN_CREATE_DOSSIER);

  }

  openModalDetailsTransmission(informationST: any) {
    this.ngxService.start()
    const config: ModalOptions = {
      initialState: {
        st_dateil:informationST,
        courrier_origine:this.data,
        numberCourrier: this.data.numero_courrier,
      }
    };
    this.bsModalRef.hide()
    let modalRef = this.modalService.show(ViewDetailsTransmissioncourrierComponent, Object.assign({}, config, {class:'modal-xl  modal-st'}));
    this.ngxService.stop()
  }
}
